import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  sparklineData = [], 
  isLoading = false,
  onClick 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  if (isLoading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 animate-pulse">
        <div className="flex items-center justify-between mb-4">
          <div className="h-4 bg-muted rounded w-24"></div>
          <div className="w-8 h-8 bg-muted rounded-lg"></div>
        </div>
        <div className="h-8 bg-muted rounded w-20 mb-2"></div>
        <div className="h-4 bg-muted rounded w-16"></div>
      </div>
    );
  }

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 transition-all duration-200 hover:shadow-soft-md ${onClick ? 'cursor-pointer hover:border-primary/20' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={icon} size={16} className="text-primary" />
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div>
          <p className="text-2xl font-bold text-foreground mb-1">{value}</p>
          <div className="flex items-center space-x-1">
            <Icon name={getChangeIcon()} size={14} className={getChangeColor()} />
            <span className={`text-sm font-medium ${getChangeColor()}`}>
              {change}
            </span>
            <span className="text-sm text-muted-foreground">vs last period</span>
          </div>
        </div>
        
        {sparklineData?.length > 0 && (
          <div className="w-16 h-8">
            <svg width="64" height="32" className="overflow-visible">
              <polyline
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="text-primary"
                points={sparklineData?.map((point, index) => 
                  `${(index / (sparklineData?.length - 1)) * 60},${32 - (point / Math.max(...sparklineData)) * 28}`
                )?.join(' ')}
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;